













































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import _ from 'lodash';
import { useRouter } from 'vivat';

import getDrivers from '@/gql/driver/getDrivers.gql';

import { PaginatorInfo } from '@/types/paginatorInfo';
import useAuth from '@/useAuth';

const DriverList = defineComponent({
  setup() {
    const { route, router } = useRouter();
    const { me } = useAuth();

    const filterDriverDisplay = ['ลำดับการสร้าง', 'แก้ไขข้อมูลล่าสุด', 'ชื่อ'];
    const filterDriverList = ['createdAt', 'updatedAt', 'name'];
    const selectedFilterDriver = ref('createdAt');

    const search = reactive({
      driverName: '',
      driverSearchInput: '',
      driverSort: [{ column: 'name', order: 'DESC' }],
      driverSortInput: 'name',
      pendingDriverSearch: false,
    });

    const drivers: Ref<any> = ref([]);
    const driverPaginatorInfo: Ref<PaginatorInfo> = ref({ currentPage: 1, perPage: 30 });
    const driversPage = ref(1);
    const { result: getDriverResult, loading: driversLoading } = useQuery(getDrivers, computed(() => {
      let page = driversPage.value;
      if (search.pendingDriverSearch) page = 1;
      return {
        page,
        searchName: search.driverSearchInput !== '' ? `%${search.driverName}%` : undefined,
        orderBy: search.driverSortInput !== '' ? search.driverSort : undefined,
      };
    }), () => ({ fetchPolicy: 'network-only' }));
    const driversResult = useResult(getDriverResult, [], (data) => data.drivers);
    watch(() => getDriverResult.value, (newVal, oldVal) => {
      if (!driversLoading.value && newVal !== oldVal) {
        if (search.pendingDriverSearch) {
          drivers.value = [];
          drivers.value = driversResult.value.data;
          driversPage.value = 1;
          search.pendingDriverSearch = false;
        } else drivers.value = [...drivers.value, ...driversResult.value.data];
        driverPaginatorInfo.value = driversResult.value.paginatorInfo;
      }
    });

    const driverNameSearchHandler = _.debounce(() => {
      driversPage.value = 1;
      search.pendingDriverSearch = true;
      search.driverName = search.driverSearchInput;
    }, 500);
    const driverSortHandler = _.debounce(() => {
      driversPage.value = 1;
      search.pendingDriverSearch = true;
      search.driverSort = [{ column: search.driverSortInput, order: 'DESC' }] as any;
    }, 300);

    const selectDriverHandler = (id: any) => {
      if (!(route.value.params.id === id)) router.push({ name: 'DriverInformation', params: { id } });
      return false;
    };

    return {
      me,
      filterDriverDisplay,
      filterDriverList,
      selectedFilterDriver,

      search,
      driverNameSearchHandler,

      drivers,
      driverPaginatorInfo,

      selectDriverHandler,

      driverSortHandler,
    };
  },
});

export default DriverList;
